import type { AllRouteEndpoints } from "../routeTypes";
import type { CompileIamCustomCssResult, CompileIamCustomSuccessResult } from "./types";
export const engagementAppGroupIdCompiledIamCustomCssCacheKeys: AllRouteEndpoints[] = [];

export const isCompileIamCustomSuccessResult = (
  result: CompileIamCustomCssResult
): result is CompileIamCustomSuccessResult => {
  return (result as CompileIamCustomSuccessResult)?.css !== undefined;
};
